import {keysStore as platformUserKeysStore} from "@mytour/platform";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {departureAddressApiService} from "./departureAddressApi.service.js";

export const departureAddressKeysStore = {
  root: ["departureAddress"] as const,
  current: () => [...departureAddressKeysStore.root, "current"] as const,
};

export function useDepartureAddress() {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: departureAddressKeysStore.current(),
    queryFn: departureAddressApiService.getDepartureAddress,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    departureAddress: data,
    isDepartureAddressLoading: isLoading,
    isDepartureAddressFetching: isFetching,
    refetchDepartureAddress: refetch,
  };
}

export function useUpdateDepartureAddress() {
  const queryClient = useQueryClient();
  const {mutateAsync, isPending} = useMutation({
    mutationFn: departureAddressApiService.updateDepartureAddress,
    onSuccess(response) {
      queryClient.setQueryData(departureAddressKeysStore.current(), response);
      // The departure address is the member's homeAddress, also surfaced by the
      // team member list (solo manager's address) and the current-user bootstrap.
      queryClient.invalidateQueries({queryKey: platformUserKeysStore.root});
    },
  });
  return {updateDepartureAddress: mutateAsync, isUpdatingDepartureAddress: isPending};
}
